var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoffee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#727831",
    fillRule: "nonzero",
    d: "M49.853 13.604c-.397-.016-.77.19-.97.533-.2.343-.194.77.017 1.106 1.189 1.968 1.478 3.57 1.375 5.123-.104 1.553-.643 3.08-1.246 4.72-1.204 3.279-2.587 7.166-.065 12.013.175.342.52.565.905.582.384.018.749-.172.955-.497.206-.324.222-.735.043-1.075-2.176-4.182-1.034-6.994.174-10.285.604-1.645 1.243-3.37 1.372-5.315.13-1.943-.293-4.083-1.679-6.375-.184-.315-.516-.514-.88-.53zm-9.789 4.09c-.397-.017-.77.188-.97.532-.2.343-.194.77.017 1.106 1.189 1.968 1.478 3.57 1.375 5.124-.104 1.553-.643 3.08-1.245 4.719-1.204 3.279-2.588 7.166-.066 12.013.175.342.52.565.905.582.384.018.749-.172.955-.496.206-.325.222-.736.043-1.076-2.176-4.182-1.033-6.992.176-10.283.604-1.646 1.241-3.373 1.37-5.317.13-1.943-.293-4.081-1.679-6.374-.184-.315-.516-.515-.88-.53zm19.579 0c-.398-.017-.772.187-.972.531-.2.344-.194.77.017 1.107 1.189 1.968 1.478 3.57 1.375 5.124-.103 1.553-.643 3.08-1.245 4.719-1.204 3.279-2.586 7.166-.065 12.013.176.342.521.565.906.582.384.018.748-.172.954-.496.207-.325.223-.736.043-1.076-2.176-4.182-1.034-6.992.175-10.283.604-1.646 1.243-3.373 1.372-5.317.13-1.943-.294-4.081-1.68-6.374-.184-.315-.515-.515-.88-.53z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#727831",
    strokeWidth: 3.467,
    transform: "translate(23.833 45.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55.25,
    cy: 15.167,
    r: 10.833
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeLinejoin: "round",
    d: "M0 0h49.833v19.5c0 9.573-7.76 17.333-17.333 17.333H17.333C7.76 36.833 0 29.073 0 19.5V0h0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.083 7.583L27.083 7.583"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.1d43de2d7e5fa8e84ed3d01feee6ada1.svg";
export { ForwardRef as ReactComponent };